import { render, staticRenderFns } from "./afficheDetail.vue?vue&type=template&id=792d1c72&scoped=true&"
import script from "./afficheDetail.vue?vue&type=script&lang=js&"
export * from "./afficheDetail.vue?vue&type=script&lang=js&"
import style0 from "./afficheDetail.vue?vue&type=style&index=0&id=792d1c72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792d1c72",
  null
  
)

component.options.__file = "afficheDetail.vue"
export default component.exports